export enum ConnectionTestResult {
  Good = 'good',
  Warning = 'warning',
  Bad = 'bad',
}

export type ConnectionTestResponse = {
  result: ConnectionTestResult;
  stats: ConnectionTestDataItem[];
};

export type ConnectionTestDataItem = {
  videoPacketLoss?: number;
  audioPacketLoss?: number;
  roundTripTime: number;
};

export type ConnectionTestConstraints = {
  video: {
    width: number;
    height: number;
    facingMode: 'user' | 'environment';
  };
  audio: boolean;
};

export enum ConnectionTestError {
  MediaDisabled = 'Creating tracks failed',
}
